import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AnchorTree, AnchorTreeNode } from '../types/anchor-tree';

/**
 * REST client for the single global anchor tree (`/anchor-tree`).
 */
@Injectable({
  providedIn: 'root'
})
export class AnchorTreeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/anchor-tree`;

  private treeCache$: Observable<AnchorTree | null> | null = null;

  getAnchorTree(): Observable<AnchorTree | null> {
    if (!this.treeCache$) {
      this.treeCache$ = this.http.get<{ tree: AnchorTree | null }>(this.apiUrl).pipe(
        map(res => res.tree),
        shareReplay(1)
      );
    }
    return this.treeCache$;
  }

  saveAnchorTree(root: AnchorTreeNode | null): Observable<AnchorTree> {
    return this.http.put<{ tree: AnchorTree }>(this.apiUrl, { root }).pipe(
      map(res => res.tree),
      tap(() => this.clearCache())
    );
  }

  refreshAnchorTreeCache(): Observable<AnchorTree | null> {
    this.clearCache();
    return this.getAnchorTree();
  }

  private clearCache(): void {
    this.treeCache$ = null;
  }
}

